import React, { Suspense } from 'react'
import { HashRouter, Route, Switch } from 'react-router-dom'
import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import { useTheme } from 'styled-components'
import Layout from '../layouts'
import routes from './routes'

const Router = () => {
  const theme = useTheme()
  const antIcon = <LoadingOutlined style={{ fontSize: 24, color: theme.colorRed }} spin />
  return (
    <HashRouter>
      <Layout>
        <Route
          render={state => {
            const { location } = state
            return (
              <Switch location={location}>
                {routes.map(({ path, Component, exact }) => (
                  <Route
                    path={path}
                    key={path}
                    exact={exact}
                    render={props => (
                      <Suspense
                        fallback={
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                            }}
                          >
                            <Spin indicator={antIcon} />
                          </div>
                        }
                      >
                        <Component {...props} />
                      </Suspense>
                    )}
                  />
                ))}
              </Switch>
            )
          }}
        />
      </Layout>
    </HashRouter>
  )
}
export default Router
